// Global application/apply link used across the site.
export const APPLY_URL = 'https://boone.managebuilding.com/Resident/rental-application/new';
